import AuthService from '@/services/AuthService';


const AUTH_LOGIN = 'AUTH_LOGIN';
const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
const AUTH_SET_USER = 'AUTH_SET_USER';

const auth = {
    state: {
        pending: false,
        user: null
    },
    mutations: {
        [AUTH_LOGIN] (state) {
            state.pending = true;
        },
        [AUTH_LOGIN_SUCCESS] (state) {
            state.pending = false;
        },
        [AUTH_SET_USER] (state, user) {
            state.user = user;
        }
    },
    actions: {
        init({commit}) {
            return new Promise((resolve, reject) => {
                AuthService.init().then((user) => {
                    commit(AUTH_SET_USER, user);
                    resolve();
                }).catch(() => {
                    reject();
                });
            });
        },
        login({commit}, creds) {
            commit(AUTH_LOGIN);
            return new Promise((resolve,reject) => {
                AuthService.login(creds).then(() => {
                    commit(AUTH_LOGIN_SUCCESS);
                    resolve();
                }).catch((error) => {
                    reject(error);
                });
            });
        },
        ['REGISTER_USER'] ({commit}, payload) {
            return new Promise((resolve) => {
                AuthService.register(payload).then(()=> {
                    resolve();
                });
            });
            
        },
        logout({commit}) {
            return new Promise(resolve => {
                AuthService.logout().then(() => {
                    commit(AUTH_SET_USER, null);
                    resolve();
                });
            });
        }
    },
    getters: {
        user: state => {
            return state.user;
        }
    }
};

export default auth;


// WEBPACK FOOTER //
// ./src/store/modules/auth.js